import type { FC } from "react";
import styled from "styled-components";
import { Button } from "@similarweb/ui-components";
import { translate } from "app/filters/i18nFilter";
import { Title } from "app/components/sharingAssetModal/components/Styled";
import { allTrackers } from "app/services/track/track";

interface IExitConfirm {
    displayMainModal: VoidFunction;
    onClose: VoidFunction;
}
const Container = styled.div`
    padding: 20px 16px 16px 24px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 92px;
    width: 360px;
`;

const FooterContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 8px;
`;

const TRACKING_MD = {
    back: "Go back",
    discard: "Discard changes",
};

type ITrackingMD = typeof TRACKING_MD;

export const ExitConfirm: FC<IExitConfirm> = (props) => {
    const { displayMainModal, onClose } = props;
    const withTracking = (actionType: keyof ITrackingMD, action: VoidFunction) => () => {
        allTrackers.trackEvent("Pop Up", "close", `Cancel restricted/${TRACKING_MD[actionType]}`);
        action();
    };
    return (
        <Container>
            <Title>{translate("asset.sharing.exit.confirm.title")}</Title>
            <FooterContainer>
                <Button
                    type={"flat"}
                    onClick={withTracking("back", displayMainModal)}
                >
                    {translate("asset.sharing.exit.confirm.back")}
                </Button>
                <Button
                    type={"warning"}
                    onClick={withTracking("discard", onClose)}
                >
                    {translate("asset.sharing.exit.confirm.discard.changes")}
                </Button>
            </FooterContainer>
        </Container>
    );
};
